<template>
	<div class="facilitator-config">
		<a-form-model ref="configForm" layout="vertical" :model="configForm" :label-col="{span: 12}" >
			<!-- 选项卡切换 -->
			<a-tabs v-model="activeTab" tabPosition="left"  class="qa-tabs">
				<!-- 微信支付参数 -->
				<a-tab-pane tab="微信支付" key="wx" class="qa-tabs-item">
					<div class="qa-table-item-1">
						<a-form-model-item label="微信APPID" has-feedback prop="wxAppid" >
							<a-input v-model="configForm.wxAppid" placeholder="请输入微信APPID" />
						</a-form-model-item>
					</div>
                    <div class="qa-table-item-1">
						<a-form-model-item label="微信APPSECRET" has-feedback prop="wxAppSecret">
							<a-input v-model="configForm.wxAppSecret" placeholder="请输入微信APPSECRET" />
						</a-form-model-item>
					</div>
				</a-tab-pane>
				
				<!-- 微信公众号参数 -->
				<a-tab-pane tab="微信公众号" key="wx_card" class="qa-tabs-item">
					<div class="qa-table-item-1">
						<a-form-model-item label="公众号APP_ID" has-feedback prop="wxCardAppId">
							<a-input v-model="configForm.wxCardAppId" placeholder="请输入微信公众号APP_ID" />
						</a-form-model-item>
						
					</div>
                    <div class="qa-table-item-1">
						<a-form-model-item label="公众号APP_SECRET" has-feedback prop="wxCardSecret">
							<a-input v-model="configForm.wxCardSecret" placeholder="请输入微信公众号APP_SECRET" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="会员卡模板ID" has-feedback prop="wxCardId">
							<a-input v-model="configForm.wxCardId" placeholder="请输入微信公众号会员卡模板ID" />
						</a-form-model-item>
					</div>
				</a-tab-pane>
				
				<!-- 支付宝支付参数 -->
				<a-tab-pane tab="支付宝支付" key="ali" class="qa-tabs-item">
					<div class="qa-table-item-1">
						<a-form-model-item label="支付宝APP_ID" has-feedback prop="aliAppId">
							<a-input v-model="configForm.aliAppId" placeholder="请输入支付宝APP_ID" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="支付宝应用私钥" has-feedback prop="aliPrivateKey">
							<a-textarea v-model="configForm.aliPrivateKey" placeholder="请输入支付宝应用私钥" :rows="4" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="支付宝公钥" has-feedback prop="alipayPublicKey">
							<a-textarea v-model="configForm.alipayPublicKey" placeholder="请输入支付宝公钥" :rows="4" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="授权TOKEN" has-feedback prop="appAuthToken">
							<a-input v-model="configForm.appAuthToken" placeholder="请输入授权TOKEN" />
						</a-form-model-item>
                    </div>
                    <div class="qa-table-item-1">
						<a-form-model-item label="第三方景区ID" has-feedback prop="scenicId">
							<a-input v-model="configForm.scenicId" placeholder="请输入第三方景区ID" />
						</a-form-model-item>
					</div>
				</a-tab-pane>
				
				<!-- 工行支付参数 -->
				<a-tab-pane tab="工行支付" key="icbc" class="qa-tabs-item">
					<div class="qa-table-item-1">
						<a-form-model-item label="公钥" has-feedback prop="icbcApigwPublicKey" :label-col="{span: 12}">
							<a-textarea v-model="configForm.icbcApigwPublicKey" placeholder="请输入工行支付APIGW_PUBLIC_KEY" :rows="4" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="私钥" has-feedback prop="icbcMyPrivateKey">
							<a-textarea v-model="configForm.icbcMyPrivateKey" placeholder="请输入工行支付MY_PRIVATE_KEY" :rows="4" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="APP_ID" has-feedback prop="icbcAppId">
							<a-input v-model="configForm.icbcAppId" placeholder="请输入工行支付APP_ID" />
						</a-form-model-item>
                    </div>
                    <div class="qa-table-item-1">
						<a-form-model-item label="商户号MerId" has-feedback prop="icbcMerId">
							<a-input v-model="configForm.icbcMerId" placeholder="请输入工行支付商户号MerId" />
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="协议编号" has-feedback prop="icbcMerPrtclNo">
							<a-input v-model="configForm.icbcMerPrtclNo" placeholder="请输入工行支付协议编号" />
						</a-form-model-item>
					</div>
				</a-tab-pane>
				
				<!-- 三方支付参数 -->
				<a-tab-pane tab="三方支付" key="third" class="qa-tabs-item">
					<div class="qa-table-item-1">
						<a-form-model-item label="商户号" has-feedback prop="thirdMchNo">
							<a-input v-model="configForm.thirdMchNo" placeholder="请输入三方支付商户号" />
						</a-form-model-item>
                    </div>
                    <div class="qa-table-item-1">
						<a-form-model-item label="应用ID" has-feedback prop="thirdAppId">
							<a-input v-model="configForm.thirdAppId" placeholder="请输入三方支付应用id" />
						</a-form-model-item>
					</div>
                    <div class="qa-table-item-1">
						<a-form-model-item label="秘钥" has-feedback prop="thirdKey">
							<a-input v-model="configForm.thirdKey" placeholder="请输入三方支付秘钥" />
						</a-form-model-item>
                    </div>
                    <div class="qa-table-item-1">
						<a-form-model-item label="支付方式" has-feedback prop="payType">
							<a-select v-model="configForm.payType">
								<a-select-option :value="2">贵昂支付宝</a-select-option>
								<a-select-option :value="3">贵昂公众号</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
                    <div class="qa-table-item-1">
						<a-form-model-item label="h5支付成功跳转URL" prop="returnUrl">
							<a-input v-model="configForm.returnUrl" placeholder="请输入h5支付成功后跳转通知界面URL" />
						</a-form-model-item>
					</div>
				</a-tab-pane>
			</a-tabs>
			
			<!-- 底部按钮 -->
			<div class="qa-modal-footer">
				<a-button type="primary" @click="handleSave" :loading="saveLoading">保存</a-button>
			</div>
		</a-form-model>
	</div>
</template>

<script>
	export default {
		name: 'FacilitatorConfig',
		props: {
			facilitatorConfigId: {
				type: [String, Number],
				default: ''
			}
		},
		data() {
			return {
				activeTab: 'wx',
				saveLoading: false,
				configForm: {
					facilitatorConfigId: '',
					wxAppid: '',
					wxAppSecret: '',
					aliAppId: '',
					aliPrivateKey: '',
					alipayPublicKey: '',
					icbcApigwPublicKey: '',
					icbcMyPrivateKey: '',
					icbcAppId: '',
					icbcMerId: '',
					icbcMerPrtclNo: '',
					thirdMchNo: '',
					thirdAppId: '',
					thirdKey: '',
					returnUrl: '',
					payType: 2,
					appAuthToken: '',
					scenicId: '',
					wxCardAppId: '',
					wxCardSecret: '',
					wxCardId: ''
				}
			}
		},
		mounted() {
			this.loadConfig()
		},
		methods: {
			// 加载配置
			async loadConfig() {
				if (!this.facilitatorConfigId) {
					return
				}
				try {
					const { data: res } = await this.$http.post(this.navigation.apiFacilitatorConfig + '/' + this.facilitatorConfigId)
					if (res.code == 200 && res.data) {
						Object.assign(this.configForm, res.data)
					}
				} catch (error) {
					console.error('加载配置失败:', error)
					this.$message.error('加载配置失败')
				}
			},
			// 保存配置
			async handleSave() {
				this.$refs.configForm.validate(async (valid) => {
					if (valid) {
						this.saveLoading = true
						try {
							let data = JSON.parse(JSON.stringify(this.configForm))
							const { data: res } = await this.$http.post(this.navigation.apiFacilitatorConfigSave, data)
							if (res.code == 200) {
								this.$message.success(res.msg)
							} else {
								this.$message.error(res.msg)
							}
						} catch (error) {
							console.error('保存配置失败:', error)
							this.$message.error('保存配置失败')
						} finally {
							this.saveLoading = false
						}
					}
				})
			}
		}
	}
</script>

<style scoped>
	
	.qa-tabs {
		margin-bottom: 20px;

	}
    .qa-tabs-item {
        padding-top: 20px;
    }
	
	.qa-table-item-2 {
		display: flex;
		margin-bottom: 16px;
	}
	
	.qa-table-item-2 .ant-form-item {
		flex: 1;
		margin-right: 16px;
	}
	
	.qa-table-item-2 .ant-form-item:last-child {
		margin-right: 0;
	}
	
	.qa-modal-footer {
		text-align: right;
		padding-top: 20px;
		border-top: 1px solid #e8e8e8;
	}
</style>
